export default __webpack_public_path__ + "7a9aef1e478538c6ee900c596367672c.mp3";